/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessPermission } from './BusinessPermission';
import {
    BusinessPermissionFromJSON,
    BusinessPermissionFromJSONTyped,
    BusinessPermissionToJSON,
    BusinessPermissionToJSONTyped,
} from './BusinessPermission';

/**
 * 
 * @export
 * @interface BusinessUpdateUserBody
 */
export interface BusinessUpdateUserBody {
    /**
     * 
     * @type {string}
     * @memberof BusinessUpdateUserBody
     */
    userId: string;
    /**
     * 
     * @type {Array<BusinessPermission>}
     * @memberof BusinessUpdateUserBody
     */
    permissions: Array<BusinessPermission>;
}

/**
 * Check if a given object implements the BusinessUpdateUserBody interface.
 */
export function instanceOfBusinessUpdateUserBody(value: object): value is BusinessUpdateUserBody {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    return true;
}

export function BusinessUpdateUserBodyFromJSON(json: any): BusinessUpdateUserBody {
    return BusinessUpdateUserBodyFromJSONTyped(json, false);
}

export function BusinessUpdateUserBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessUpdateUserBody {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'permissions': ((json['permissions'] as Array<any>).map(BusinessPermissionFromJSON)),
    };
}

export function BusinessUpdateUserBodyToJSON(json: any): BusinessUpdateUserBody {
    return BusinessUpdateUserBodyToJSONTyped(json, false);
}

export function BusinessUpdateUserBodyToJSONTyped(value?: BusinessUpdateUserBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'permissions': ((value['permissions'] as Array<any>).map(BusinessPermissionToJSON)),
    };
}

